import { InlineEdit } from 'ui/inlineEdit';
import { CSSContainer } from './DescriptionInput.styled';

type DescriptionInputProps = {
  /** If description is loading. */
  isLoading: boolean;
  /** Callback function when description is changed. */
  onChange: null | ((value: string) => void);
  /** Description string. */
  value: string;
};

const DescriptionInput = ({ isLoading, onChange, value = '' }: DescriptionInputProps) => {
  return (
    <CSSContainer>
      <div className="description-input-label">
        <span>Description</span>
      </div>
      {onChange ? (
        <InlineEdit
          data-test="description-inline-input"
          value={value}
          onChange={onChange}
          placeholder={isLoading ? '' : 'Add a description'}
        />
      ) : (
        <span>{value}</span>
      )}
    </CSSContainer>
  );
};

export default DescriptionInput;
